import { useMutation, useQuery } from "@apollo/client";
import { GET_PRODUCTS, LIST_BRANDS, LIST_CATEGORY } from "../apollo/queries";
import useFilters from "../core/hooks/useFilters";
import { getSelectedStoreDetails } from "../utils/helperFunctions";
import { useCallback, useEffect, useState } from "react";
import { showSwal } from "../utils/swal";
import { UPDATE_PRODUCT_STATUS } from "../apollo/mutations";

const useProducts = () => {
  const [selectedBrand, setSelectedBrand] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const {
    search,
    sort,
    debouncedValue,
    onChange,
    onChangeSort,
    pagination,
    handlePageChange,
  } = useFilters();

  const { loading, error, data, refetch } = useQuery(GET_PRODUCTS, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        name: debouncedValue,
        store_id: getSelectedStoreDetails("id"),
        sort: sort?.value,
        brand_id: selectedBrand?.value,
        category_id: selectedSubCategory
          ? selectedSubCategory.value
          : selectedCategory?.value,
      },
    },
    fetchPolicy: "network-only",
  });

  const { data: brandData, error: brandError } = useQuery(LIST_BRANDS, {
    variables: {
      storeId: getSelectedStoreDetails("id"),
    },
    fetchPolicy: "cache-and-network",
  });

  if (brandError) {
    console.log("Error While Getting Brands", brandError);
  }

  console.log("brandData", brandData);

  const brandList =
    brandData?.listBrand?.map((brand) => ({
      label: brand.name,
      value: brand.id,
    })) || [];

  const { data: categoryData, error: categoryError } = useQuery(LIST_CATEGORY, {
    variables: {
      storeId: getSelectedStoreDetails("id"),
    },
    fetchPolicy: "cache-and-network",
  });

  if (categoryError) {
    console.log("Error While Getting Categories", categoryError);
  }

  const categoryList =
    categoryData?.listCategories
      ?.filter((item) => item.parent_id === null)
      ?.map((item) => ({
        value: item.id,
        label: item.name,
      })) || [];

  const subCategoryList =
    categoryData?.listCategories
      ?.filter((item) => item?.parent_id === selectedCategory?.value)
      ?.map((item) => ({
        value: item.id,
        label: item.name,
      })) || [];

  useEffect(() => {
    if (subCategoryList?.length === 0) {
      setSelectedSubCategory(null);
    }
  }, [subCategoryList]);

  console.log("categoryList", categoryList);
  console.log("categoryData", categoryData);
  console.log("subCategoryList", subCategoryList);
  console.log("selectedCategory", selectedCategory);

  const [updateStatus] = useMutation(UPDATE_PRODUCT_STATUS, {
    onCompleted: () => {
      showSwal({
        title: "Cancelled!",
        text: "Product has been deleted.",
      });
      refetch();
    },
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  const onDelete = useCallback((updateProductStatusId) => {
    showSwal({
      title: "Are you sure you want to delete?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      onConfirm: () => {
        updateStatus({ variables: { updateProductStatusId } });
      },
    });
  }, []);

  console.log("brandList", brandList);

  return {
    values: {
      data: data?.allProduct || [],
      total: data?.allProduct?.total || 0,
      loading,
      search,
      sort,
      brandList,
      categoryList,
      subCategoryList,
      selectedBrand,
      selectedCategory,
      selectedSubCategory,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allProduct?.total || 0,
      },
    },
    states: {
      setSelectedBrand,
      setSelectedCategory,
      setSelectedSubCategory,
    },
    functions: {
      onChange,
      onChangeSort,
      handlePageChange,
      onDelete,
    },
  };
};

export default useProducts;
